module.exports = __webpack_public_path__ + "static/media/limchukang2.14a46750.png";